import { activationValueText } from "./roofingV2QualificationView";

const NOT_CONFIGURED = "not configured";

function readField(source, key) {
  if (!source || typeof source !== "object" || Array.isArray(source)) {
    return NOT_CONFIGURED;
  }
  if (!Object.prototype.hasOwnProperty.call(source, key) || source[key] == null) {
    return NOT_CONFIGURED;
  }
  return source[key];
}

function capabilitiesView(value) {
  if (!value || typeof value !== "object" || Array.isArray(value)) {
    return { status: NOT_CONFIGURED, capabilities: [] };
  }
  return {
    status: null,
    capabilities: Object.keys(value).map((key) => ({
      key,
      value: typeof value[key] === "boolean" ? value[key] : NOT_CONFIGURED,
    })),
  };
}

export function roofingV2ChannelView(settings) {
  const channel = settings && settings.channel_profile;
  const capabilities = capabilitiesView(settings && settings.notification_capabilities);
  return {
    confirmationMode: activationValueText(readField(channel, "confirmation_mode")),
    capabilitiesStatus: capabilities.status,
    capabilities: capabilities.capabilities,
  };
}
